import { render, staticRenderFns } from "./EditPhoneDialog.vue?vue&type=template&id=988152e6&scoped=true&"
import script from "./EditPhoneDialog.vue?vue&type=script&lang=js&"
export * from "./EditPhoneDialog.vue?vue&type=script&lang=js&"
import style0 from "./EditPhoneDialog.vue?vue&type=style&index=0&id=988152e6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "988152e6",
  null
  
)

export default component.exports